"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import type { MouseEventHandler, ReactNode } from "react";

type TrackedSignupLinkProps = {
  children: ReactNode;
  className?: string;
  ctaLabel: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  placement: string;
};

const SIGNUP_PATH = "/signup";

export function TrackedSignupLink({
  children,
  className,
  ctaLabel,
  onClick,
  placement,
}: TrackedSignupLinkProps) {
  const pathname = usePathname();

  const trackSignupClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const landingPath = pathname || "/";
    void import("@/lib/analytics")
      .then(({ ANALYTICS_EVENTS, trackEvent }) => {
        trackEvent(ANALYTICS_EVENTS.landingCtaClicked, {
          cta_label: ctaLabel,
          destination: SIGNUP_PATH,
          landing_path: landingPath,
          placement,
        });
      })
      .catch(() => {
        // Navigation must continue if the optional analytics chunk fails.
      });
    onClick?.(event);
  };

  return (
    <Link
      href={SIGNUP_PATH}
      prefetch={false}
      className={className}
      onClick={trackSignupClick}
    >
      {children}
    </Link>
  );
}
